<template>
    <div class="loginBox">
      <div class="loginForm">
        <div class="loginText">
            {{ loginType == 1 ? 'Sign Up' : loginType == 2 ? 'Forgot Password' : 'Log In' }}
        </div>
        <!-- <div class="loginIndex">
          <div :class="{ active: loginIndex == 0 }" @click="handleChangeIndex(0)">Phone Login</div>
          <div :class="{ active: loginIndex == 1 }" @click="handleChangeIndex(1)">Email Login</div>
        </div> -->
        <el-form :model="ruleForm"  :rules="rules" ref="ruleForm"  class="demo-ruleForm" autocomplete="off">
          <el-form-item prop="mobile" >
            <el-input
              v-model.trim="ruleForm.mobile"
              placeholder="Please enter phone number"
              autocomplete="off"
              name="mobile_no_autofill"
              inputmode="numeric"
            ></el-input>
          </el-form-item>
          <!-- Please enter password -->
          <el-form-item  prop="password" v-if="loginType == 0">
            <el-input type="password" v-model="ruleForm.password"  placeholder="Please enter password" show-password autocomplete="current-password"></el-input>
          </el-form-item>
            <!-- 验证码 -->
          <el-form-item  prop="code" v-if="loginType == 1 || loginType == 2">
            <el-input
              type="text"
              v-model.trim="ruleForm.code"
              placeholder="Please enter verification code"
              autocomplete="one-time-code"
              name="otp_no_autofill"
              inputmode="numeric"
            >
                <!-- <el-button slot="append" @click="handleSendCode" >{{ sendText }}</el-button> -->
              <div slot="append"><CountDown :mobile="ruleForm.mobile" /></div>
            </el-input>
          </el-form-item>
          <el-form-item prop="email" v-if="loginType == 1">
            <el-input  v-model="ruleForm.email" placeholder="Please enter email"></el-input>
          </el-form-item>
            <!-- 重新设置密码 -->
          <el-form-item  prop="password" v-if="loginType == 1 || loginType == 2">
            <el-input type="password" v-model="ruleForm.password"  placeholder="Set new password" show-password autocomplete="new-password"></el-input>
          </el-form-item>
          <el-form-item  prop="confirm_password" v-if="loginType == 1 || loginType == 2">
            <el-input type="password" v-model="ruleForm.confirm_password"  placeholder="Please confirm password" show-password autocomplete="new-password"></el-input>
          </el-form-item>
        </el-form>
        <div class="passBox" v-if="loginType == 0">
          <div @click="handleSetPass">Forgot Password?</div>
        </div>
        <el-button :style="{margin:loginType == 1 ? '0 0 1rem 0' : loginType == 2 ? '0' : '1rem 0'}" class="resterBtn" type="primary" @click="submitForm('ruleForm')">{{ loginType == 1 ? 'Sign Up' : loginType == 2 ? 'Reset Password' : 'Log In' }}</el-button>
        <div class="resterBox" v-if="loginType == 0 || loginType == 1" >
          <div>{{ loginType == 1 ? 'Already have an account? ' : "Don't have an account? " }}</div>
          <div class="goRester" @click="handleRegister">{{ loginType == 1 ? 'Go to Login' : 'Go to Sign Up' }}</div>
        </div>
        <div class="remark">
          By signing up, you agree to
          <span @click="handleOpen('service_terms')">Terms of Service</span>
          and
          <span @click="handleOpen('privacy_policy')">Privacy Policy</span>
        </div>
      </div>
      <van-popup
        v-model="show"
        closeable
        round
        close-icon-position="top-right"
        position="bottom"
        :style="{ height: '70%' }"
      >
        <div class="agreement">
          <div class="agreementTitle">{{ agreementTitle }}</div>
          <div v-if="agreementLoading" class="agreementLoading">Loading...</div>
          <div v-else class="agreementBody" v-html="agreementHtml"></div>
        </div>
      </van-popup>
    </div>
</template>
<script>
import CountDown from '@/components/countdown/index.vue'
export default {
  name: 'loginPage',
  props:{
    loginType:{
        type:Number,
        default:0
    }
  },
  components:{
    CountDown
  },
  data(){
    return {
      show:false,
      agreementTitle:'',
      agreementHtml:'',
      agreementLoading:false,
      agreementCache: {
        service_terms: '',
        privacy_policy: ''
      },
      loginIndex:0,
      sendText:'Get Code',
      time:30,
      timer:null,
      ruleForm:{
        app_id:10001,
        mobile:'',
        password:'',
        email:'',
        confirm_password:'',
        code:''
      },
      rules:{
        mobile:[{ required: true, message: 'Please enter phone number', trigger: 'blur' },],
        password:[
          { required: true, message: 'Please enter password', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              // 注册and忘记密码页面需要校验密码格式
              if(this.loginType == 1 || this.loginType == 2){
                if(!value){
                  callback(new Error('Please enter password'))
                }else if(value.length < 8){
                  callback(new Error('Password must be at least 8 characters'))
                }else if(!/[a-zA-Z]/.test(value)){
                  callback(new Error('Password must include letters'))
                }else if(!/[0-9]/.test(value)){
                  callback(new Error('Password must include numbers'))
                }else{
                  callback()
                }
              }else{
                // 登录页面只需校验非空
                if(!value){
                  callback(new Error('Please enter password'))
                }else{
                  callback()
                }
              }
            },
            trigger: 'blur'
          }
        ],
        code:[{ required: true, message: 'Please enter verification code', trigger: 'blur' },],
        confirm_password:[
          { required: true, message: 'Please confirm password', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if ((this.loginType == 1 || this.loginType == 2) && value !== this.ruleForm.password) {
                callback(new Error('The two passwords do not match'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        email:[{ required: true, message: 'Please enter email', trigger: 'blur' },],
      },
    }
  },
  watch: {
    // 切换登录/注册/忘记密码时，强制清空表单，避免浏览器/输入法自动填充残留
    loginType: {
      immediate: true,
      handler() {
        this.resetAuthForm()
      }
    }
  },
  methods:{
    resetAuthForm(){
      // 仅清理敏感字段（手机号/验证码/密码等），避免“有时进来预填”的问题
      this.ruleForm.mobile = ''
      this.ruleForm.code = ''
      this.ruleForm.password = ''
      this.ruleForm.confirm_password = ''
      this.ruleForm.email = ''
      this.$nextTick(() => {
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.clearValidate && this.$refs.ruleForm.clearValidate()
        }
      })
    },
    // 跳转到注册页面
    handleRegister(){
        if( this.loginType == 0 ){
            this.$router.push('/register')
        }else{
            this.$router.push('/login')
        }
    },
    // 切换时表单重置验证
    handleChangeIndex(val){
        this.loginIndex = val
        if(this.$refs.ruleForm ){
            this.$refs.ruleForm.resetFields()
        }
    },
    // 跳转到忘记密码页面
    handleSetPass(){
        this.$router.push('/setPass')
    },
    // 点击发送验证码
    handleSendCode(){
        let time = Number(localStorage.getItem('time'))
        this.sendText = time + 's'
        // if( this.timer != null ) return
        this.timer = setInterval(()=>{
            if( Number(localStorage.getItem('time')) <= 0 ){
                clearInterval(this.timer)
                this.timer = null
                this.sendText = 'Resend'
                localStorage.setItem('time',30)
            }else{
                let nowTime = Number(localStorage.getItem('time')) - 1
                localStorage.setItem('time',nowTime)
                this.sendText = nowTime + 's'
            }
        },1000)
    },
     submitForm(){
      this.$refs.ruleForm.validate(valid=>{
        if( valid ){
          // 登录
          if( this.loginType == 0 ){
            this.$store.dispatch('Login',this.ruleForm).then(res=>{
              this.$router.push('/')
            }).catch(err=>{
              this.$message.error(err)
            })
          }else if( this.loginType == 1 ){
            // 注册
            const { mobile, password, confirm_password, code, email, app_id } = this.ruleForm
            this.$api.register({ mobile, password, confirm_password, code, app_id, email }).then(res=>{
              if( res.code == 1 ){
                this.$message.success('Sign up successful')
                this.$router.push('/login')
              }else{
                this.$message.error(res.msg)
              }
            })
          }else if( this.loginType == 2 ){
            // 忘记密码 - 重置密码
            const { mobile,password,code } = this.ruleForm
            this.$api.resetPassword({mobile,password,code}).then(res=>{
              if( res.code == 1 ){
                this.$message.success('Password reset successful')
                this.$router.push('/login')
              }else{
                this.$message.error(res.msg)
              }
            })
          }
        }else{
          return false
        }
      })
    },
    async handleOpen(type){
      const titleMap = {
        service_terms: 'Terms of Service',
        privacy_policy: 'Privacy Policy'
      }
      this.agreementTitle = titleMap[type] || 'User Agreement'
      this.show = true
      // 先用缓存，避免重复请求
      if(this.agreementCache && this.agreementCache[type]){
        this.agreementHtml = this.agreementCache[type]
        return
      }
      this.agreementLoading = true
      this.agreementHtml = ''
      try{
        const res = await this.$api.getRegisterAgreements()
        if(res && res.code == 1){
          const data = res.data || {}
          const html = type === 'service_terms' ? (data.service_terms && data.service_terms.service_terms) || ''
            : (data.privacy_policy && data.privacy_policy.privacy_policy) || ''
          this.agreementHtml = html || ''
          this.agreementCache[type] = this.agreementHtml
        }else{
          this.$message && this.$message.error(res && res.msg ? res.msg : 'Failed to load agreement')
        }
      }catch(e){
        this.$message && this.$message.error('Failed to load agreement')
      }finally{
        this.agreementLoading = false
      }
    },
  }
}
</script>
<style lang="scss" scoped>
    .loginBox{
      width: 100%;
      height: calc(100% - 44px);
      background: #ECF7F3;
      display: flex;
      justify-content: center;
      align-items: center;
      .loginText{
        font-size: 1.25rem;
        text-align: left;
        font-weight: bold;
        margin-bottom: 1rem;
      }
      .loginIndex{
        display: flex;
        align-items: center;
        padding:.35rem .5rem;
        width: fit-content;
        height: 2.5rem;
        background: #DAEBE3;
        border-radius: .25rem;
        box-sizing: border-box;
        font-size: .875rem;
        color: #666666;
        margin-bottom: 1rem;
        div{
          width: 6.25rem;
        }
        .active{
          color: #1E3C3E;
          padding: 0 .5rem;
          background: #fff;
          height: 100%;
          border-radius: .25rem;
          display: flex;
          justify-content: center;
          align-items: center;
          box-sizing: border-box;
        }
      }
      .loginForm{
        width: 90%;
        padding: 1rem;
        height:auto;
        background: #fff;
        border-radius: .5rem;
        box-sizing: border-box;
        ::v-deep .el-input-group--append {
          border: 1px solid #dcdfe6;
          border-radius: 4px;
          overflow: hidden;
          background: #fff;
          transition: border-color .2s cubic-bezier(.645,.045,.355,1);
        }
        ::v-deep .el-input-group--append .el-input__inner {
          border: none;
          border-radius: 0;
        }
        ::v-deep .el-input-group--append .el-input-group__append {
          padding: 0;
          border: none;
          background: #fff;
          border-radius: 0;
        }
        ::v-deep .el-input-group--append .el-input-group__append .verification-container {
          height: 38px;
        }
        ::v-deep .el-input-group--append:focus-within {
          border-color: #409eff;
        }
        .resterBtn{
          width: 100%;
          margin: 1rem 0;
          background: #1E3C3E;
          border-color: #D2D8D8;
        }
        .resterBox{
          color: #999999;
          font-size: .875rem;
          display: flex;
          justify-content: center;
          .goRester{
            color: #1E3C3E;
            text-decoration: underline;
          }
        }
        .remark{
          color: #999999;
          font-size: .75rem;
          margin-top: 1rem;
          span{
            color: #1E3C3E;
            cursor: pointer;
          }
        }
      }
      .passBox{
        display: flex;
        justify-content: flex-end;
        color: #666666;
        font-size: .75rem;
      }
      .resterBtn{
        width: 100%;
        background: #1E3C3E;
        border-color: #D2D8D8;
      }
      .remark{
        color: #999999;
        font-size: .75rem;
        span{
          color: #1E3C3E;
          cursor: pointer;
        }
      }
    }
    .agreement{
      padding: 1rem;
      box-sizing: border-box;
      height: 100%;
      overflow: hidden;
      .agreementTitle{
        font-size: 1rem;
        font-weight: 600;
        color: #333;
        padding-right: 2rem; // 给关闭按钮留空间
        margin-bottom: 0.75rem;
      }
      .agreementLoading{
        color: #999;
        font-size: .875rem;
        text-align: center;
        padding: 1rem 0;
      }
      .agreementBody{
        height: calc(100% - 2rem);
        overflow: auto;
        color: #333;
        font-size: .875rem;
        line-height: 1.6;
      }
      ::v-deep img{
        max-width: 100%;
        height: auto;
        display: block;
      }
    }
</style>
